import { typeCreatorV2 } from 'redux/utils/common';

//  [REDUCER][TYPE]
export const SET_NEWS_LIST: string = typeCreatorV2(
  'NewsReducer',
  'SetNewsList'
);

export const SET_ADD_NEWS: string = typeCreatorV2('NewsReducer', 'SetAddNews');
export const SET_TEXT_SEARCH: string = typeCreatorV2(
  'NewsReducer',
  'SetTextSearch'
);
export const DELETE_NEWS: string = typeCreatorV2('NewsReducer', 'DeleteNews');
